import React from 'react';
import classnames from 'classnames';
import {useField} from 'formik';
import styles from './styles.module.scss';

const FieldCheckbox = ({
                         fieldId,
                         ...rest
                       }) => {
  const [field, meta] = useField(fieldId);
  return (
    <InputCheckbox
      meta={meta}
      {...field}
      {...rest}
    />
  );
};

export const InputCheckbox = ({
                                fieldId,
                                value,
                                label = null,
                                customContainerStyles = null,
                                disabled,
                                meta,
                                ...rest
                              }) => {
  return (
    <label className={classnames(
      styles.checkboxRow,
      customContainerStyles,
      {[styles.disabled]: disabled}
    )}
    >
      <span className={classnames(styles.checkboxSwitch, styles.reverse)}>
        <input
          type="checkbox"
          checked={value}
          disabled={disabled}
          {...rest}
        />
        <span className={styles.checkboxSlider}></span>
      </span>
      <span className={styles.checkboxText}>{label}</span>
    </label>
  );
};

export default FieldCheckbox;
